"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var SvgGoUp = function SvgGoUp(props) {
  return React.createElement("svg", __assign({
    width: 1792,
    height: 1792,
    viewBox: "0 0 1792 1792"
  }, props), React.createElement("title", null, "switch (bottom)"), React.createElement("g", {
    id: "ab70919b-6878-4a79-bb69-55678e0e3bbe",
    "data-name": "\\u30E9\\u30D9\\u30EB"
  }, React.createElement("polygon", {
    points: "448.1 763.79 784.68 427.21 784.68 1082.06 1007.89 1082.06 1007.89 427.21 1344.48 763.79 1502.31 605.96 896.35 0 896.29 0.06 896.23 0 290.27 605.96 448.1 763.79"
  }), React.createElement("rect", {
    y: 1352,
    width: 1792,
    height: 440
  })));
};
exports.default = SvgGoUp;